<template>
	<div class="lock-status">
		<div v-if="isLoading || isParentLoading" class="spinner"></div>
		<div v-if="!isLoading && !isParentLoading && !lock" class="text-inactive"><i class="fa fa-ban"></i> Unknown</div>
		<span v-if="lock && lock.battery_level === 'fresh'" class="text-success"><i class="fa fa-battery-full"></i> Fresh</span>
		<span v-if="lock && lock.battery_level === 'good'" class="text-success"><i class="fa fa-battery-three-quarters"></i> Good</span>
		<span v-if="lock && lock.battery_level === 'low'" class="text-warning"><i class="fa fa-battery-half"></i> Low</span>
		<span v-if="lock && lock.battery_level === 'critical'" class="text-danger"><i class="fa fa-battery-quarter"></i> Critical!</span>
		<span v-if="lock && lock.battery_level === 'none'" class="text-danger"><i class="fa fa-battery-empty"></i> None!</span>
		<span v-if="lock && lock.battery_level === 'unknown'" class="text-inactive"><i class="fa fa-question-circle"></i> Unknown</span>

		<span v-if="lock && lock.battery_level === 'wall_reader' && lock.online" class="text-success"><i class="fa fa-plug"></i> Powered</span>
	</div>
</template>
<style scoped>
	.lock-status {
		width: 80px;
		text-align: center;
	}
</style>
<script>
	import Hardware from "../Services/Hardware";

	export default {

		props: ['lockData', 'lockId', 'isParentLoading'],

		data: () => { return {
			isLoading: true,
			lock: null,
		}},

		mounted() {

			if(this.lockData) {
				this.lock = this.lockData;
				this.isLoading = false;
				return;
			}

			this.refreshLockData();

		},

		methods: {

			refreshLockData() {
				this.isLoading = true;

				Hardware.getLock(this.lockId)
					.then((lock) => {

						if(lock.lock_type === 'wall_reader' || lock.lock_type === 'wall_reader_pin') {
							lock.battery_level = 'wall_reader';
                        }

						this.lock = lock;
						this.isLoading = false;
					})
					.catch((err) => {
						this.isLoading = false;
					});
			}

		}

	}
</script>
